import './App.css';
import { MantineProvider } from '@mantine/core';
import Layout from './components/layout';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Category from './pages/Category/[category]';
import Department from './pages/Department/[department]';
import SubCategory from './pages/SubCat/[subcat]';
import SearchByKey from './pages/Search/[key]';
import NotFound from './pages/NotFound';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

export const CurrentLocale = localStorage.getItem('language') ?? 'en'

function App() {
  const [initialized, setInitialized] = useState(false)
  const { i18n } = useTranslation()

  useEffect(() => {
    if (!initialized) {
      i18n.changeLanguage(CurrentLocale);
      setInitialized(true);
    }
  }, [initialized, i18n]);
  return (
    <>
      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          colorScheme: 'light',
          colors: {
            'hkc': ['#0848ab', '#d14629', '#444444'],
            'offWhite': ['#ffffffb0', '#F0F0F0']
          },
          other: {
            skeletonTimeout: 0,
            containerSize: 1160,
            chineseFont: {
              MSJhengHei: 'MSJhengHei',
              PMingLiu: 'PMingLiu'
            },
            englishFont: {
              BerlinSans: 'BerlinSansFBDemi',
              SanSerif: 'san-serif'
            },
            titleFont: CurrentLocale == 'en' ? 'BerlinSansFBDemi' : 'MSJhengHei',
            layout: {
              slashHeight: 10,
              orangeSquare: 10,
              sectionTitleFontSize: 22,
              title: {
                fontSize: 36,
                fontWeight: 900,
                lineHeight: 1.1
              }
            }
          }
        }}
      >

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/ContactUs" element={<ContactUs />} />
              <Route path="/Category/:catId" element={<Category />} />
              <Route path="/Department/:deptId" element={<Department />} />
              <Route path="/SubCat/:subCatId" element={<SubCategory />} />
              <Route path="/Search/:key" element={<SearchByKey />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </MantineProvider>
    </>
  );
}

export default App;
